// dependencies
import App from './App.svelte';

// polyfills
import './utils/polyfills';

// styles
import './styles/index.scss';

// Clear console in development
if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// Mount the app
new App({
  target: document.getElementById('graphic'),
});
